<template>
  <div v-if="notificationList.length > 0" class="class-reminder-container">
    <div
      v-for="(notification, index) in notificationList"
      :key="notification.id || index"
      class="reminder-card"
      :style="{ zIndex: notificationList.length - index }"
    >
      <div class="card-header">
        <div class="close-btn-wrapper">
          <span class="close-btn" @click="handleClose(notification)" />
        </div>
        <div class="header-left">
          <span v-if="notification.type === 'start_soon'" class="icon icon-bell" />
          <span v-else-if="notification.type === 'in_progress'" class="icon icon-clock" />
          <span class="title">{{ notification.title }}</span>
        </div>
      </div>
      <div class="card-content">
        <div v-html="formatContent(notification.content, notification.className)" />
      </div>
      <div class="card-footer">
        <button class="join-btn" @click="handleJoin(notification)">
          {{ notification.buttonText || 'Join Now' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'ClassReminder',
  mixins: [mixin],
}
</script>

<style lang="scss" scoped>
.class-reminder-container {
  position: fixed;
  top: 20px;
  right: 158px;
  z-index: 9999;
  pointer-events: none;

  .reminder-card {
    padding: 24px;
    width: 440px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 4px 20px #0000000d;
    margin-bottom: 16px;
    pointer-events: all;
    position: relative;

    .card-header {
      .header-left {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2px;
        flex: 1;

        .icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
        }

        .icon-bell {
          background-image: url('~assets/images/component-new/icon-bell.png');
        }

        .icon-clock {
          background-image: url('~assets/images/component-new/icon-clock.png');
        }

        .title {
          font-family: 'Poppins';
          font-size: 16px;
          font-weight: 700;
          vertical-align: bottom;
          line-height: 1;
          color: #000;
          word-break: break-word;
          overflow-wrap: break-word;
        }
      }

      .close-btn-wrapper {
        text-align: right;
      }

      .close-btn {
        display: inline-block;
        width: 14px;
        height: 14px;
        background-image: url('~assets/images/component-new/icon-close.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .card-content {
      margin-top: 12px;
      font-family: 'Poppins';
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #000;

      ::v-deep p {
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      ::v-deep strong {
        color: #ff5a00;
        font-weight: 700;
      }
    }

    .card-footer {
      margin-top: 12px;
      text-align: right;

      .join-btn {
        background: #ff5a00;
        color: #fff;
        border: none;
        border-radius: 100px;
        padding: 12px 30px;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover {
          background: #ff5a00d9;
        }
      }
    }
  }
}

</style>
